import React from 'react';
import './PaymentSuccess.scss';


import {imagePath} from '../index';
/*
import PaymentSuccess from './components/PaymentSuccess/PaymentSuccess';

function App() {
  return (
    <PaymentSuccess
      refNumber="000085752257"
      status="Successful"
      sender="Cyber Coeus"
      type="Bank Transfer"
      dateTime="12/09/2025 12:34 PM"
      amount="$5,000,000.00"
    />
  );
}

export default App;

*/

const PaymentSuccess = ({
  refNumber,
  status='successful',
  sender,
  type,
  dateTime,
  amount
}) => {
  //Transfer from 
  return (
    <div className="payment-success">
      <div className="payment-card">
        <img 
          src={`${imagePath}b/logo.svg`} 
          className="logo"
        />
        <h2 className="transfer-title">{sender}</h2>
        <h1 className="amount">{amount}</h1>
        <div className={`status-badge ${status}`}>{/*
          <span className="status-icon">✓</span>*/}
          Payment {status}
        </div>
      </div>

      <div className="details-card">
        <h3>Payment Details</h3>
        <div className="details-list">
          <DetailRow label="Ref Number" value={refNumber} />
          <DetailRow label="Payment Status" value={status} success />
          <DetailRow label="Invoice Brief" value={sender} />
          <DetailRow label="Transaction Type" value={type} />
          <DetailRow label="Date and Time" value={dateTime} />
        </div>
      </div>

      <div className="footer">
        <p className="footer-text">
          Our Bank helps over 2 million customers achieve their financial goals by helping them save and invest with ease. Put that extra cash to use without putting it at risk with Our Bank.
        </p>
        {/*<p className="copyright">
          Copyright © 2024. All rights reserved.
        </p>*/}
      </div>
    </div>
  );
};

const DetailRow = ({ label, value, success }) => (
  <div className="detail-row">
    <span className="label">{label}</span>
    <span className={`value ${success ? 'success' : ''}`}>{value}</span>
  </div>
);

export default PaymentSuccess;